import axios from "axios";
import {
    SEARCH_CMS,
    SEARCH_CMS_ERROR,
} from "./types";

import { setAlert } from "./alerts";

import { sidebarRoutes } from "../../routes/index";

const baseUrl = process.env.REACT_APP_BASE_URL;

// FILTER NAV WITH TABS OR CHILDREN
const handleFilterSubRoutes = (route, subRoute, search) => {
    const subContent = route[subRoute].filter(e => e.name && (!search || e.name.toLowerCase().includes(search.toLowerCase())))
    
    if (!(subContent.length > 0)) {
        return []
    }

    return subContent
}

// FILTER NAV BY SEARCH TEXT
const filterRoutes = (route, search) => {
    
    if (route.children?.length > 0) {
        return handleFilterSubRoutes(route, 'children', search)

    } else if (route.tabs?.length > 0) {
        return handleFilterSubRoutes(route, 'tabs', search)

    } else if (route.id && ((search && route.id.toLowerCase().includes(search)) || !search)) {
        return [{ ...route, name: route.id }]

    } else {
        return []
    }
}

const getPagesMatchingSearch = (search) => {
    let totalMatches = []

    for (let route of sidebarRoutes) {
        const matches = filterRoutes(route, search)

        totalMatches = [
            ...totalMatches,
            ...matches
        ]
    }

    return totalMatches
}

// Return only page paths for default results
export const getDefaultSearchResults = () => async (dispatch) => {

    const navigationMatches = getPagesMatchingSearch()

    dispatch({
        type: SEARCH_CMS,
        payload: {
            'Go To': navigationMatches,
        },
    });

};

// Search all content on the cms
export const searchCMS = (term, limit = 6) => async (dispatch) => {
    try {

        if (!term) {
            dispatch({
                type: SEARCH_CMS,
                payload: {},
            });
            return
        }

        const response = await axios.get(`${baseUrl}/api/search/cms/${encodeURIComponent(term)}/${limit}`);

        const navigationMatches = getPagesMatchingSearch(term)

        dispatch({
            type: SEARCH_CMS,
            payload: {
                'Go To': navigationMatches,
                ...response?.data ? response.data : {},
            },
        });

        // dispatch(setAlert("Course Type added successfully!", "success"));
    } catch (err) {
        dispatch(setAlert("Could not search the CMS", "danger"));
        dispatch({
            type: SEARCH_CMS_ERROR,
            payload: [],
        });
    }
};
